import superagent from 'superagent'
import { arrayIsEqual } from '../lib/util'
import isNil from 'lodash/isNil'

export const userSettingsSet = settings => {
  return {
    type: 'USER_SETTINGS_SET',
    payload: settings
  }
}

export const setUserSettingsChangesLastCalled = () => {
  let now = new Date()
  return {
    type: 'USER_SETTINGS_CHANGES_LAST_CALLED_SET',
    payload: now.toISOString()
  }
}

export const userSettingsGetRequest = () => (dispatch, getState, token) => {
  let auth = token
  const userSettings = getState().userSettings
  return !isNil(userSettings) && userSettings.length > 0 ? Promise.resolve(userSettings) :
    new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/UserSetting/Get`)
        .set('Authorization', `Bearer ${auth}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            let userSettings = res.body
            userSettings.map(s => {
              try {
                s.valueArray = JSON.parse(s.value)
              } catch (e) {
                s.valueArray = []
                s.value = '[]'
              }
            })

            if (userSettings.length === 0) {
              dispatch(userSettingsCreateRequest(1, '[81]'))
                .then(res => { resolve(res) })
            } else {
              dispatch(userSettingsSet(userSettings))
              resolve(userSettings)
            }

          }
        })
    })
}

export const userSettingsChangesRequest = asOfDate => (dispatch, getState, token) => {
  let auth = token
  let lastCalledDate = asOfDate
  if (!lastCalledDate) {
    lastCalledDate = getState().userSettingsLastCalled
  }
  //Update last called date
  dispatch(setUserSettingsChangesLastCalled())

  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/UserSetting/Changes?asOfDate=${lastCalledDate}&page=0&pageSize=2.14m`)
      .set('Authorization', `Bearer ${auth}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          let userSettings = res.body.userSettings
          userSettings.map(s => {
            s.valueArray = JSON.parse(s.value)
          })
          resolve(userSettings)
          dispatch(userSettingsSet(userSettings))
        }
      })
  })
}

export const userSettingsCreateRequest = (settingId, value) => (dispatch, getState, token) => {
  let auth = token
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/UserSetting/Create/${settingId}?value=${value}`)
      .set('Authorization', `Bearer ${auth}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          const oldSettings = getState().userSettings,
            newSettings = oldSettings.concat(res.body)
          dispatch(userSettingsSet(newSettings))
          resolve(newSettings)
          //dispatch(userSettingsChangesRequest())
        }
      })
  })
}

export const userSettingsUpdateActiveLayers = settingId => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    let userSettings = getState().userSettings.find(s => s.settingId == settingId)
    let activeLayers = getState().activeLayers.map(a => a.id)
    //let layers = userSettings && userSettings.valueArray ? userSettings.valueArray : []
    //let resultingLayers = layers.filter(l => l != layerId)

    if (userSettings) {
      dispatch(userSettingsUpdateRequest(settingId, JSON.stringify(activeLayers)))
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      dispatch(userSettingsCreateRequest(settingId, JSON.stringify(activeLayers)))
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    }
  })
}

export const userSettingsRemoveLayer = (settingId, layerId) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    let userSettings = getState().userSettings.find(s => s.settingId == settingId)
    let layers = []

    if (userSettings) {
      const layersDictionary = getState().layersDictionary,
        layer = layersDictionary[layerId],
        overlay = layer.overlayLayerId ? layer.overlayLayerId : null
      let valueArray = userSettings.valueArray ? userSettings.valueArray : JSON.parse(userSettings.value)
      userSettings.valueArray = valueArray && valueArray !== '' ? valueArray : []
      layers = [...userSettings.valueArray]
      layers = layers.filter(l => {
        return l != layerId && l != overlay
      })
    }
    const compUserSettings = getState().userSettings
    compUserSettings.forEach(setting => {
      if (setting.settingId === settingId) {
        setting.valueArray = layers
        setting.value = JSON.stringify(layers)
      }
    })
    if (userSettings) {
      dispatch(userSettingsSet(compUserSettings))
      dispatch(userSettingsUpdateRequest(settingId, JSON.stringify(layers), false))
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      dispatch(userSettingsCreateRequest(settingId, JSON.stringify(layers)))
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    }
  })
}

export const userSettingsAddLayer = (settingId, layerId) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    const userSettings = [].concat(getState().userSettings),
      currSetting = userSettings.find(s => s.settingId == settingId) ? userSettings.find(s => s.settingId == settingId) : {},
      settings = currSetting && currSetting.valueArray && currSetting.valueArray.length ? currSetting.valueArray : [],
      layersDictionary = getState().layersDictionary,
      layer = layersDictionary && layersDictionary[layerId] ? layersDictionary[layerId] : null

    if (settings.indexOf(layerId) !== -1 || layer === null) {
      return resolve(getState().userSettings)
    } else {
      const pruned = settings.filter(setting => !isNaN(setting))
      pruned.push(layerId)
      if (settingId === 1 && layer.overlayLayerId) {
        pruned.push(layer.overlayLayerId)
      }
      currSetting.value = JSON.stringify(pruned)
      currSetting.valueArray = pruned
      if (!userSettings.some(s => s.settingId == settingId)) {
        userSettings.push(currSetting)
        dispatch(userSettingsCreateRequest(settingId, JSON.stringify(pruned)))
          .then(res => {
            resolve(res)
          })
      } else {
        dispatch(userSettingsUpdateRequest(settingId, JSON.stringify(pruned), false))
          .then(res => {
            resolve(res)
          })
      }
      dispatch(userSettingsSet(userSettings))
    }
  })
}

export const userSettingsUpdateRequest = (settingId, value) => (dispatch, getState, token) => {
  let auth = token
  // dispatch(userSettingsSet(settingId, JSON.parse(value)))
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI__}/UserSetting/Update/${settingId}?value=${value}`)
      .set('Authorization', `Bearer ${auth}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          const oldSettings = getState().userSettings,
            newSettings = oldSettings.map(setting => {
              if (setting.settingId === settingId) {
                return res.body
              }
              return setting
            })
          // dispatch(userSettingsSet(newSettings))
          resolve(newSettings)
          //dispatch(userSettingsChangesRequest())
        }
      })
  })
}
